import { createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
        overflowY: "scroll",
      },
      body: {
        height: "100%",
        width: "100%",
      },
      ".second-font": {
        fontFamily: "'Bai Jamjuree', sans-serif",
      },
      ".third-font": {
        fontFamily: "'Alegreya', serif",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
      ".MuiTableCell-root": {
        fontSize: "1rem",
      },
      ".paper-title": {
        color: theme.palette.custom.Paper.titleColor,
      },
      ".paper-value": {
        color: theme.palette.custom.Paper.valueColor,
        fontSize: "1.75rem",
        fontWeight: 700,
      },
      ".increase": {
        color: "#27ae60",
        fontWeight: 500,
      },
      ".decrease": {
        color: "#fd4040",
        fontWeight: 500,
      },
      ".MuiButtonBase-root.Mui-disabled": {
        cursor: "not-allowed",
        pointerEvents: "all",
      },
    },
  })
);

export default function GlobalStyles() {
  useStyles();
  return null;
}
